<template>
    <virtual-list
        ref="tree"
        :height="height"
        :listData="localListData"
        :keygen="options.keygen"
        :childKey="options.childKey"
        :renderTitle="options.renderTitle"
        :emptyText="emptyText"
        :timeout="options.timeout"
        :renderItem="options.renderItem"
        :treeOpt="{
          mode: mode,
          checked: localValue,
          showCheckbox,
          line: options.line,
          treeRender: options.treeRender,
          checkedKey: options.checkedKey || 'checked'
        }"
        @on-check-change="checkChange"
        @on-query-cbk="queryCbk"
    ></virtual-list>
</template>

<script>
import burgeonConfig from '../../assets/config';
import VirtualList from '../../components/virtual-list';

const prefixCls = `${burgeonConfig.prefixCls}tree-v`;

export default {
    name: 'TreeV',
    components: {VirtualList},
    props: {
        height: {
            type: Number
        },
        listData: {
            type: Array | Function
        },
        nodeInteraction:{
            type: Boolean,
            default: true
        },
        options: {
            type: Object,
            default: () => ({
                keygen: 'ID',
                childKey: 'children',
                renderTitle: 'title',
                line: false,
                timeout: 17,
                checkedKey: 'checked'
            })
        },
        // mode 0: full  1: child only  ##2: parent only
        mode: {
            type: Number,
            default: 0
        },
        value: {
            type: Array,
            default: () => []
        },
        showCheckbox: {
            type: Boolean,
            default: false
        },
        emptyText: {
            type: String,
            default: '暂无数据'
        }
    },
    computed: {
        classes() {
            return `${prefixCls}`;
        },
        // list() {
        //     const res = this.handleLastNode(this.localListData);
        //     return res;
        // }
    },
    data() {
        return {
            localListData: [],
            localValue: []
        };
    },
    created() {
        console.log('listData', this.listData)
    },
    watch: {
        listData: {
            handler (newV, oldV) {
                if (newV && newV.then) {
                    newV.then(v => this.localListData = this.handleLastNode(JSON.parse(JSON.stringify(v))));
                } else {
                    const cloneList = JSON.parse(JSON.stringify(newV));
                    this.localListData = this.handleLastNode(cloneList);
                }
                // console.log('this.localListData', this.localListData)
            },
            immediate: true,
            deep:true
        },
        value: {
            handler (newV, oldV) {
                this.localValue = JSON.parse(JSON.stringify(newV));
            },
            immediate: true,
            deep:true
        }
    },
    methods: {
        update() {
            this.$refs.tree.updateView();
        },
        expandAll() {
            this.$refs.tree.expandAll();
        },
        collapseAll() {
            this.$refs.tree.collapseAll();
        },
        clearAll() {
            this.localValue = [];
            this.$refs.tree.clearAll();
        },
        checkAll() {
            this.$refs.tree.checkAll();
        },
        handleCheck() {
            this.$refs.tree.handleCheck();
        },
        showAll(type) {
            this.$refs.tree.showAll(type);
        },
        checkChange(checked, node) {
            this.$emit('on-check-change', checked, node);
        },
        queryCbk(has, key) {
            this.$emit('on-query-cbk', has, key);
        },
        search(query) {
            this.$refs.tree.query(query);
        },
        getFlatList() {
            return this.$refs.tree.localListData;
        },
        handleLastNode(list){
            list.map((item, index) => {
                // 对数据进行处理
                // item.checked = item[this.options.checkedKey];
                item.last = index === list.length - 1;
                if (item[this.options.childKey] && item[this.options.childKey].length) {
                    this.handleLastNode(item[this.options.childKey]);
                }
            });
            return list;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/FcComponents/treeV/treeV.vue